export default "/react/promoIcon-2f04e40e.svg";